import {
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
  Select,
  SelectGhostTrigger,
  SelectItem
} from "@prismicio/editor-ui"
import type { SelectContent } from "@prismicio/types-internal/lib/content"
import type { Select as SelectT } from "@prismicio/types-internal/lib/customtypes"

import { getFieldLabel, getFieldPlaceholder } from "./utils"

interface Props {
  content: SelectContent | undefined
  field: SelectT
  id: string
  onContentChange: (content: SelectContent | undefined) => void
  readOnly: boolean
}

export function SelectField(props: Props) {
  const { content, field, id, onContentChange, readOnly } = props

  const placeholder = getFieldPlaceholder(field)
  const defaultValue = getDefaultValue(field)
  const value = content?.value ?? defaultValue

  return (
    <Field>
      <FieldIcon name="arrowDropDownCircle" />
      <FieldLabel htmlFor={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        {/* TODO: how can we indicate when this element is not editable? */}
        <Select
          id={id}
          size="large"
          color="grey"
          value={value}
          renderTrigger={() => (
            <SelectGhostTrigger id={id} placeholder={placeholder} />
          )}
          onValueChange={(value) => {
            if (!readOnly) {
              onContentChange(updateContent(value))
            }
          }}
        >
          {field.config?.options?.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </Select>
      </FieldControl>
    </Field>
  )
}

function getDefaultValue(field: SelectT): string | undefined {
  return field.config?.default_value === undefined
    ? undefined
    : field.config.options?.[0]
}

function updateContent(value: string): SelectContent | undefined {
  return value.length === 0
    ? undefined
    : { __TYPE__: "FieldContent", type: "Select", value }
}
